import { HEAT_CATEGORIES } from "../lib/scoring";

export function HeatmapLegend({ category, ranges }) {
  if (category === "composite") return null;
  const range = ranges?.[category];
  if (!range) return null;
  const label =
    HEAT_CATEGORIES.find((c) => c.key === category)?.label || category;

  return (
    <div className="heatmap-legend" data-testid="heatmap-legend">
      <span className="hl-label">{label}</span>
      <span className="hl-min" data-testid="heatmap-legend-min">
        {range.min.toFixed(1)}
      </span>
      <span className="hl-bar" />
      <span className="hl-max" data-testid="heatmap-legend-max">
        {range.max.toFixed(1)}
      </span>
    </div>
  );
}
